import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface StudySettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  autoPlayAudio: boolean;
  onAutoPlayAudioChange: (value: boolean) => void;
}

const StudySettingsModal: React.FC<StudySettingsModalProps> = ({
  isOpen,
  onClose,
  autoPlayAudio,
  onAutoPlayAudioChange,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        className="w-full max-w-md bg-white dark:bg-gray-800 rounded-xl shadow-xl p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Configurações</h2>
          <button
            onClick={onClose}
            aria-label="Fechar"
            className="p-1 rounded-lg text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <div className="flex items-center justify-between gap-4">
          <div>
            <p className="text-sm font-medium text-gray-900 dark:text-white">Áudio automático</p>
            <p className="text-xs text-gray-500 dark:text-gray-400">
              Reproduzir o texto em voz alta automaticamente
            </p>
          </div>
          <button
            type="button"
            role="switch"
            aria-checked={autoPlayAudio}
            onClick={() => onAutoPlayAudioChange(!autoPlayAudio)}
            className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors duration-200 ${
              autoPlayAudio ? 'bg-blue-600' : 'bg-gray-300 dark:bg-gray-600'
            }`}
          >
            <span
              className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform duration-200 ${
                autoPlayAudio ? 'translate-x-5' : 'translate-x-0.5'
              }`}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudySettingsModal;
